import React, { useRef, useState, useCallback } from 'react';
import { useHistory, useLocation, Link } from 'react-router-dom';
import Form, {
  Item,
  RequiredRule,
  EmailRule,
  ButtonItem,
  ButtonOptions,
  Label
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
// MODIFICATION 1: Import the notify component for user feedback
import notify from 'devextreme/ui/notify';
import "./ResetPassword.css";
const { REACT_APP_SERVER_URL } = process.env;


export default function ResetPassword() {
  const history = useHistory();
  const location = useLocation();
  const formRef = useRef(null);

  const [formData, setFormData] = useState({ email: location.state?.email || '' });
  const [loading, setLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const onFormOptionChanged = useCallback((e) => {
    if (e.name === 'formData') {
      setFormData(e.value);
    }
  }, []);

  // MODIFICATION 2: Update handleSubmit to call the real API
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = formRef.current?.instance;
    const result = form?.validate();

    if (!result?.isValid) return;

    setLoading(true);

    try {
      const apiUrl = `${REACT_APP_SERVER_URL}/ResetPassword/RequestReset`; // Make sure this route is correct

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData.email)
      });

      // --- MODIFIED ERROR HANDLING BLOCK ---
      if (!response.ok) {
        let errorMessage = `Error: ${response.status} ${response.statusText}`;

        // Try to parse the response as JSON, but don't fail if it's not
        try {
          const errorData = await response.json();
          // If the backend sends a specific message, use it
          errorMessage = errorData.Message || errorData.message || errorMessage;
        } catch (jsonError) {
          // The response was not JSON. The default errorMessage is fine.
          console.error("Could not parse error response as JSON", jsonError);
        }

        throw new Error(errorMessage);
      }

      setFormSubmitted(true);

    } catch (error) {
      console.error('Error sending reset link:', error);
      notify({
        message: error.message, // Now this will contain a more informative message
        type: 'error',
        displayTime: 3500,
        width: 'auto'
      }, 'center', 'top');
    } finally {
      setLoading(false);
    }
  };

  const navigateToLogin = () => {
    history.push('/login');
  };

  // The rest of the component remains the same...
  return (
    <div className="reset-password-page">
      <div className="form-container">
        <div className="form-content">
          <div className="form-header">
            <span className="form-icon">🔒</span>
            <h2>איפוס סיסמה</h2>
            <p>
              כדי לאפס את סיסמתך, הזן את כתובת המייל שבאמצעותה נרשמת.
            </p>
          </div>

          {formSubmitted ? (
            <div className="success-message">
              <p>
                <strong>הקישור בדרך אליך! ✅</strong>
              </p>
              <p>
                שלחנו לכתובת <strong>{formData.email}</strong> קישור לאיפוס סיסמה.
                הקישור בתוקף ל-15 דקות הקרובות. יש לבדוק גם את תיבת דואר הזבל.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} aria-labelledby="form-title">
              <Form
                ref={formRef}
                formData={formData}
                onOptionChanged={onFormOptionChanged}
                disabled={loading}
              >
                <Item
                  dataField="email"
                  editorType="dxTextBox"
                  editorOptions={{
                    placeholder: 'your@email.com',
                    mode: 'email',
                    elementAttr: {
                      dir: 'ltr'
                    }
                  }}
                >
                  <Label text="כתובת אימייל" />
                  <RequiredRule message="שדה אימייל הוא חובה" />
                  <EmailRule message="כתובת אימייל אינה תקינה" />
                </Item>

                <ButtonItem>
                  <ButtonOptions width="100%" type="default" useSubmitBehavior={true}>
                    <span className="dx-button-text">
                      {loading ? (
                        <LoadIndicator width="24px" height="24px" visible={true} />
                      ) : (
                        'שלח קישור לאיפוס'
                      )}
                    </span>
                  </ButtonOptions>
                </ButtonItem>

                {!formSubmitted && (
                  <Item>
                    <div
                      style={{ textAlign: "center", marginBottom: "10px" }}
                    >
                      <Link to="/login" className={"link-button"}>
                        חזרה למסך ההתחברות
                      </Link>
                    </div>
                  </Item>
                )}
              </Form>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}